// Who may edit a page layout: admins, scoped editors on their pages, and owners of a page (e.g. a business page they built).
export const canEditLayout = (user, layoutKey) => Boolean(layoutKey) && (
  user?.role === "admin"
  || (user?.role === "editor" && (user?.editor_pages || []).includes(layoutKey))
  || (user?.owned_layouts || []).includes(layoutKey)
);
